import React from 'react'
import './SnowLines.scss'
import { getStyles } from "src/helpers"

interface ISnowLines {
    backClassName?: string
    frontClassName?: string
    isIndex?: boolean
}

const SnowLines: React.FC<ISnowLines> = (props) => {
    const { backClassName, frontClassName, isIndex = false } = props

    const getFrontStyles = getStyles("snow-lines__front", [{
        decision: isIndex,
        name: "index"
    }], frontClassName)
    const getBackStyles = getStyles("snow-lines__back", [{
        decision: isIndex,
        name: "index"
    }], backClassName)

    return (
        <>
            <div className={getFrontStyles}></div>
            <div className={getBackStyles}></div>
        </>
    )
}

export default SnowLines